import * as React from "react";
const SvgFiRrTractor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tractor_svg__a)">
      <path
        fill="#062147"
        d="M11 17h-.1a5 5 0 0 0-.729-1.756l.073-.073a1 1 0 0 0-1.414-1.414l-.073.073A5 5 0 0 0 7 13.1V13a1 1 0 0 0-2 0v.1a5 5 0 0 0-1.756.729l-.073-.073a1 1 0 0 0-1.414 1.414l.073.073A5 5 0 0 0 1.1 17H1a1 1 0 0 0 0 2h.1c.127.627.375 1.223.729 1.756l-.073.073a1 1 0 0 0 1.414 1.414l.073-.073A5 5 0 0 0 5 22.9v.1a1 1 0 1 0 2 0v-.1a5 5 0 0 0 1.756-.729l.073.073a1 1 0 0 0 1.414-1.414l-.073-.073c.355-.533.603-1.13.73-1.757h.1a1 1 0 1 0 0-2m-5 4a3 3 0 1 1 0-6 3 3 0 0 1 0 6m18-9a4 4 0 0 0-4-4V6a1 1 0 0 0-2 0v2h-2.446l-3.531-5.65A4.97 4.97 0 0 0 7.783 0H6a3 3 0 0 0-3 3v5a3 3 0 0 0-3 3 1 1 0 1 0 2 0 1 1 0 0 1 1-1h17a2.013 2.013 0 0 1 1.6 3.2l-1.555 2.073c-6.729-2-8.559 8.3-1.545 8.727a4.522 4.522 0 0 0 3.226-7.634L23.2 14.4A4.02 4.02 0 0 0 24 12M5 3a1 1 0 0 1 1-1h1.783a2.98 2.98 0 0 1 2.544 1.41L13.2 8H5zm13.5 19a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tractor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTractor;
